<div class="dialog--title" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" [cdkDragFreeDragPosition]="position" (cdkDragEnded)="onDragEnded($event)">
  <h6 mat-dialog-title>
    {{ data.sysText.changePasswordDialog_title }}
  </h6>
  @if (isMobile$ | async) {
    <span class="spacer"></span>
    <button
      type="button"
      class="button-reset"
      [mat-dialog-close]
      [aria-label]="data.sysText.cancel"
      [disabled]="isSubmitting$ | async">
      <mat-icon class="button-icon">close</mat-icon>
    </button>
  }
</div>

<mat-dialog-content [formGroup]="form">
  <p class="subtitle1 bottom-margin">
    {{ data.sysText.changePasswordDialog_subtitle }}
  </p>
  <mat-form-field color="accent">
    <mat-label>{{ data.sysText.currentPassword | titlecase }}</mat-label>
    <input
      matInput
      [type]="hideCurrentPassword ? 'password' : 'text'"
      formControlName="currentPassword"
      autocomplete="current-password"/>
      <!-- mat hint for spacing -->
      <mat-hint></mat-hint>
      <mat-error>{{ currentPassword.errors?.required ? (data.sysText.required | capitalizefirst) : currentPassword.errors?.msError }}</mat-error>
      <button type="button" class="button-reset" matSuffix [attr.aria-label]="data.sysText.showPassword_ariaLabel" [attr.aria-pressed]="!hideCurrentPassword" (click)="hideCurrentPassword = !hideCurrentPassword">
        <mat-icon>{{ hideCurrentPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
      </button>
    </mat-form-field>
    <mat-form-field color="accent">
      <mat-label>{{ data.sysText.newPassword | titlecase }}</mat-label>
      <input
        matInput
        [type]="hideNewPassword ? 'password' : 'text'"
        formControlName="newPassword"
        autocomplete="new-password"/>
        <mat-error>{{ newPassword.errors?.required ? (data.sysText.required | capitalizefirst) : newPassword.errors?.msError }}</mat-error>
        <button type="button" class="button-reset" matSuffix [attr.aria-label]="data.sysText.showPassword_ariaLabel" [attr.aria-pressed]="!hideNewPassword" (click)="hideNewPassword = !hideNewPassword">
          <mat-icon>{{ hideNewPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>
      </mat-form-field>
      <app-password-validator
        [password]="newPassword.value"
        (validationUpdate)="passwordValid = $event"
        [reqList]="data.passwordRequirements">
      </app-password-validator>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
      @let isSubmitting = isSubmitting$ | async;
      @if (!(isMobile$ | async)) {
        <button
          mat-stroked-button
          class="button"
          [mat-dialog-close]
          color="accent"
          [disabled]="isSubmitting">
          {{ data.sysText.cancel }}
        </button>
      }
      <!-- save keeps focus while saving: showProgress lays the spinner over its label, disabledInteractive keeps it focusable, and the guard blocks clicks.
      it stays focusable when the form is invalid too (backend errors make it invalid while it has focus), so the guard repeats the form checks -->
      <button
        mat-stroked-button
        class="button"
        color="accent"
        [disabled]="isSubmitting || form.invalid || !passwordValid"
        disabledInteractive
        [showProgress]="isSubmitting"
        [attr.aria-label]="isSubmitting ? data.sysText.submitting_ariaLabel : null"
        (click)="!isSubmitting && !form.invalid && passwordValid && changePassword()">
        {{ data.sysText.changePassword }}
        <mat-spinner progressIndicator diameter="30" color="accent"></mat-spinner>
      </button>
    </mat-dialog-actions>
